const detectIfInIframe = () => {
  if (typeof window === 'undefined') {
    return false
  }

  return window?.location !== window?.parent.location
}

export default detectIfInIframe
